/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Suspension_MessageInputs */

const en__field_suspension_message = /** @type {(inputs: _Field_Suspension_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suspension reason`)
};

const de__field_suspension_message = /** @type {(inputs: _Field_Suspension_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspendierungs Grund`)
};

/**
* | output |
* | --- |
* | "suspension reason" |
*
* @param {_Field_Suspension_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_suspension_message = /** @type {((inputs?: _Field_Suspension_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Suspension_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_suspension_message(inputs)
	return de__field_suspension_message(inputs)
});